/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type TrainerTestimonialHomogenizedTypeEnum =
  (typeof TrainerTestimonialHomogenizedTypeEnum)[keyof typeof TrainerTestimonialHomogenizedTypeEnum];

export const TrainerTestimonialHomogenizedTypeEnum = {
  trainertestimonial: 'trainertestimonial',
} as const;
